import Yup from '@vizir-banking/banking-app-core/dist/utils/yup/yup';
import {requiredField} from '@vizir-banking/banking-app-core/dist/utils/validation-messages';

const schema = Yup.object({
  legalNature: Yup.string().nullable().required(requiredField),
  establishmentFormat: Yup.string().nullable().required(requiredField),
});

export default schema;
